import { AttributeSelectionWidget, AttributeCategorySelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
  attribute_ids: {
    'ui:widget': AttributeSelectionWidget,
  },
  attribute_category_ids: {
    'ui:widget': AttributeCategorySelectionWidget,
  },
});

export default uiSchema;
